import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import Product from './model';
import * as Constants from './constants';

// Delete when Manage Plan is rewritten to epics
export const fetchProducts = (institutionId, validOn, validTo, ageGroupId, includeDiscontinued) => {
    return RESTClient.getAuthenticated('v2/products', {
        institutionId,
        validOn,
        validTo,
        includeDiscontinued,
        ageGroupIds: ageGroupId,
        behaviors: 1,
    });
};

export const fetchProductsObservable = (
    institutionId,
    validOn,
    validTo,
    ageGroupId,
    includeDiscontinued,
    includePricesForAllPricingGroups,
) => {
    return RESTClient.getAuthenticatedObservable('v2/products', {
        institutionId,
        validOn,
        validTo,
        includeDiscontinued,
        ageGroupIds: ageGroupId,
        behaviors: 1,
        includePricesForAllPricingGroups,
    }).map(productData => ({
        products: productData.products.map(Product.fromAPI),
        behaviors: new BehaviorsCollection(productData.behaviors),
    }));
};

export const createProduct = product => {
    return RESTClient.postAuthenticatedObservable('v2/products', {product}).map(newProductData => ({
        product: Product.fromAPI(newProductData.product),
    }));
};

export const updateProduct = (product, force = false) => {
    return RESTClient.putAuthenticatedObservable(
        `v2/products?force=${force}`,
        {product},
        {
            ignoredErrors: [Constants.RequiresForceUpdateErrorCode],
        },
    ).map(newProductData => ({
        product: Product.fromAPI(newProductData.product),
    }));
};

export const deleteProduct = product => {
    return RESTClient.deleteAuthenticatedObservable(`v2/products/${product.id}`, {product}).map(removedProductData => ({
        product: Product.fromAPI(removedProductData.product),
    }));
};

export const restoreProduct = product => {
    return RESTClient.postAuthenticatedObservable(`v2/products/${product.id}/restore`).map(restoredProductData => ({
        product: Product.fromAPI(restoredProductData.product),
    }));
};

export const fetchProduct = (productId, includePricesForAllPricingGroups) => {
    let url = `v2/products/${productId}`;
    if (includePricesForAllPricingGroups) {
        url += '?includePricesForAllPricingGroups=true';
    }
    return RESTClient.getAuthenticatedObservable(url).map(productData => ({
        products: productData.products.map(product => Product.fromAPI(product)),
    }));
};

export const unscheduleProduct = productId => {
    return RESTClient.postAuthenticatedObservable(`v2/products/${productId}/unschedule`).map(unscheduledData => ({
        unscheduledProductVersionId: unscheduledData.productVersionId,
        remainingVersions: unscheduledData.remainingVersions.map(Product.fromAPI),
    }));
};
